exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/loan-officer-region-reference/subregion-list/subregion-list.component.css
// module id = ../../../../../src/app/loan-officer-region-reference/subregion-list/subregion-list.component.css
// module chunks = main